import { Selection } from '@heroui/react';
import { useCallback, useEffect, useState } from 'react';

import { useListSubCatalogs } from '../../../hooks/useListSubCatalogs';

export const NO_CATALOG = 'NO_CATALOG';

interface DropdownItem {
  id: string;
  name: string;
}

const stickyItems = [
  {
    id: NO_CATALOG,
    name: 'Hide all products',
  },
  {
    id: '',
    name: 'Show all products',
  },
];

export const useSubCatalogDropdown = (supplierId?: string) => {
  const [selectedItems, setSelectedItems] = useState<Selection>(new Set([]));
  const { subcatalogList, loading, error, fetchAll } =
    useListSubCatalogs(supplierId);

  useEffect(() => {
    if (supplierId) {
      fetchAll();
    }
  }, [supplierId, fetchAll]);

  const dropDownItems: DropdownItem[] = subcatalogList.map(
    ({ id, name }: { id: string; name: string }) => ({
      id,
      name: `${name} - ${id}`,
    })
  );

  const onSelectionChange = useCallback((keys: Selection) => {
    setSelectedItems(keys);
  }, []);

  const onSave = useCallback(async () => {
    if (!supplierId) return;

    try {
      // TODO: Implement save functionality with GraphQL mutation
      // For now, just a placeholder for the mutation
      await Promise.resolve();
    } catch (err) {
      // Handle error appropriately
    }
  }, [supplierId, selectedItems]);

  return {
    dropDownItems,
    stickyItems,
    loading,
    error,
    selectedItems,
    onSelectionChange,
    onSave,
  };
};
